import { IParamsToSend } from '@base/@types/providers/Budget/conciliation'

export const reportRequest: IParamsToSend = {
  empresa: {
    ids: [],
    agrupar: false
  },
  loja: {
    ids: [],
    agrupar: true
  },
  categoriaCompacta: {
    ids: [],
    agrupar: false
  },
  categoria: {
    ids: [],
    agrupar: false
  },
  gerenteCategoria: {
    ids: [],
    agrupar: false
  },
  gerenteProduto: {
    ids: [],
    agrupar: false
  },
  ano: {
    ids: [],
    agrupar: false
  },
  mes: {
    ids: [],
    agrupar: false
  },
  historico: {
    ids: [],
    agrupar: false
  },
  operacao: {
    ids: [],
    agrupar: false
  }
}
